import React, { useState, useEffect, useContext, useMemo } from "react";
import axios from "axios";
import moment from "moment";
import DataTable from "react-data-table-component";
import { NotificationManager } from "react-notifications";
import { makeStyles } from "@mui/styles";
import LinearProgress from "@mui/material/LinearProgress";
import Tooltip from "@mui/material/Tooltip";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import Button from "components/CustomButtons/Button.js";
import styled from "styled-components";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import UserService from "services/UserService";
import { getMITMSchedules } from "services/ConfigServices";
import { computertext } from "variables/MITM/computer.js";
import Dialog from "@mui/material/Dialog";
import { withStyles } from "@mui/styles";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import { typeData, stateData } from "variables/MITM/lists/computer.js"
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import { geittext } from "variables/MITM/geit";
import { Pilotage, Override, Data as DataIcon } from "components/CustomIcon/CustomIcon";
import { Laptop, Desktop } from "components/CustomIcon/CustomIcon";

const GroupCell = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

const Container = styled.div`
  border: solid;
  border-width: 1px;
  border-color: #EEEEEE;
  background-color: white;
  margin-top: -0.5px;
  padding-top: 5px;
  overflow-x: auto;
  width: 100%;
`;

const PlanMenuButton = styled.div`
    width:30px;
    height:30px;
    padding-top: 3px;
    padding-left: 3px;
    padding-right: 3px;
    margin-right: 5px;
    cursor: pointer;
    border: 1px solid;
    border-color: #8080804d;
    border-radius: 4px;
`;
const ExpandableContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0.5rem 4rem 2rem;
`;
const ExpandableElement = styled.div`
  display: flex;
  flex-direction: row;
  margin-left: ${(props) => props.marginleft};
`;

const ElementTitle = styled.div`
  font-weight: 600;
  font-size: 12px;
  font-family: "Source Sans Pro",sans-serif;
`;

const SelectedText = styled.div`
  margin-left: 4px;
  font-weight: 400;
  font-size: 14px;
  font-family: "Source Sans Pro",sans-serif;
`;

const NoData = styled.p`
  font-size: 14px;
  font-weight: 600;
  margin-top: 20px;
  opacity: 1;
`;

const SubHeader = styled.div`
  display: flex;

`;
const SearchDiv = styled.div`
  display: flex;

`;

const useStyles2 = makeStyles((theme) => ({
  planicon: {
    display: 'block',
    position: 'absolute',
    cursor: 'pointer',
    background: '#ffffffd6',
    borderRadius: 10,
  },
  planicongreen: {
    display: 'block',
    position: 'absolute',
    cursor: 'pointer',
    color: "#91C73C",
    background: '#ffffffd6',
    borderRadius: 10,
  },
  planmenu: {
    display: 'flex',
    aligItems: "flex-end",
  },
  plansubmenu: {
    display: 'flex',
    marginTop: 7,
    marginLeft: 5,
  },
  planmenuicon: {
    width: "20px",
    height: "20px",
    marginLeft: "1px",
    marginTop: "1px",
  },
  planmenubutton: {
    background: "#FFFFFF"
  },
  planmenubuttonpressed: {
    background: "#91C73C"
  },
  planmenubuttonfspressed: {
    background: "#9798A0"
  },
  searchField: {
    fontSize: "0.9rem",
    marginTop: "7px",
    "& .MuiInputBase-input": {
      padding: "5px 5px",
    },
    "& .MuiInputBase-root": {
      fontSize: "0.9rem",
    },
  },
}));

const DialogContent = withStyles((theme) => ({
  root: {
    padding: '16px',
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: '8px',
  },
}))(MuiDialogActions);

const useStyles = makeStyles(styles);

const RTComputers = (props) => {
  const currentusertype = localStorage.getItem('userType');
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const mitm_control_schedules = permis.includes("mitm_control_schedules");
  const appContext = useContext(AdvancedSearchContext);
  const { groupInfoListById } = appContext;
  const { wpgroup, computers, policies, selectedComputers, setSelectedComputers, filteredComputers, setFilteredComputers } = props;
  const [schedulesData, setSchedulesData] = useState([]);
  const [point, setPoint] = useState(null);
  // const [selectedComputers, setSelectedComputers] = useState([]);
  const [openPoint, setOpenPoint] = useState(false);
  const [openPointData, setOpenPointData] = useState(false);

  const [displayonlylap, setDisplayonlylap] = useState(false);
  const [displayonlydesk, setDisplayonlydesk] = useState(false);
  // const [displayonlysaver, setDisplayonlysaver] = useState(false);

  const classes = useStyles();
  const classes2 = useStyles2();

  console.log(localStorage.getItem('locale'));

  const handleDisplayonlylapChange = () => {
    if (displayonlydesk && !displayonlylap)
      setDisplayonlydesk(false);
    setDisplayonlylap(!displayonlylap);
  }
  const handleDisplayonlydeskChange = () => {
    if (displayonlylap && !displayonlydesk)
      setDisplayonlylap(false);
    setDisplayonlydesk(!displayonlydesk);
  }

  const getIcon = (row) => {
    let Icon = typeData.find((x) => x.id == row.typepc)?.icon;
    if (Icon) {
      return <Icon style={{ fontSize: "1.6rem", marginRight: "6px", marginLeft: "-20px" }} />
    }
  }


  const computerscolumns = [
    {
      name: computertext.name,
      selector: (row) => row.computername,
      sortable: true,
      // maxWidth: "12rem",
      cell: (row) => <>{getIcon(row)} {row.computername}</>,
    },
    {
      name: computertext.type,
      selector: (row) => row.typepc,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => typeData.find((x) => x.id == row.typepc)?.name || ""
    },
    {
      name: computertext.state,
      selector: (row) => row.state,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => stateData.find((x) => x.id == row.state)?.name || ""
    },
    {
      name: computertext.policy,
      selector: (row) => policies.find((x) => x.id == row.policy)?.name || "",
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => policies.find((x) => x.id == row.policy)?.name || ""
    },
    {
      name: computertext.lastconnexion,
      selector: (row) => row.lastconnexion && moment(row.lastconnexion).isValid()
        ? moment(row.lastconnexion).format("DD/MM/YYYY HH:mm") : "",
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => row.lastconnexion && moment(row.lastconnexion).isValid()
        ? moment(row.lastconnexion).format("DD/MM/YYYY HH:mm") : ""
    },
    // {
    //   name: computertext.os,
    //   selector: (row) => row.os,
    //   sortable: true,
    //   // cell: (row) => row.os,
    // },
    {
      name: "",
      sortable: false,
      width: "7rem",
      // eslint-disable-next-line react/button-has-type
      // eslint-disable-next-line react/display-name
      cell: (row) => (
        <>

          <div className="actions-right">
            {mitm_control_schedules && (
              <>
                <Tooltip title="Règles de pilotage">
                  <Button
                    onClick={editPoint(row)}
                    color={"warning"}
                    className={classes.actionButtonDense}
                  >
                    <Pilotage fontSize="large" />
                  </Button>
                </Tooltip>
                <Tooltip title="Voir les données">
                  <Button
                    onClick={viewPointData(row)}
                    color={"info"}
                    className={classes.actionButtonDense}
                  >
                    <DataIcon fontSize="large" />
                  </Button>
                </Tooltip>
              </>
            )}
          </div>
        </>
      ),
    },
  ];


  const viewPointData = (row) => async () => {
    let obj = computers.find((o) => o.id === row.id);
    setPoint(obj);
    handleViewPointDataOpen();
  };
  const editPoint = (row) => async () => {
    let obj = computers.find((o) => o.id === row.id);

  }

  const ExpandableComponent = props => {
    const { data } = props;
    const datadisplay = computers.filter((x) => x.equipment === data.id);

    return (
      <Container>
        {/* <DataTable
          paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
          noDataComponent={<NoData>Aucun PDL à afficher</NoData>}
          noHeader={true}
          columns={pointscolumns}
          persistTableHead
          data={datadisplay}
          striped={true}
        //theme="solarized"
        /> */}
      </Container>
    );
  };

  const [filterTextEquipment, setFilterTextEquipment] = useState("");
  const [resetPaginationToggleEquipment, setResetPaginationToggleEquipment] = useState(false);
  const SearchComponentEquipment = ({ filterText, onFilter, onClear }) => (
    <>
      <div style={{ marginTop: "-7px", marginRight: "10px" }}>
        <TextField
          type="search"
          variant="outlined"
          margin="normal"
          size="small"
          autoFocus="true"
          value={filterText}
          onChange={onFilter}
          className={classes2.searchField}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </div>
    </>
  );
  useEffect(() => {
    setFilteredComputers(computers.filter(
      (item) =>
        (item.computername && item.computername.toLowerCase().includes(filterTextEquipment.toLowerCase())) &&
        ((!displayonlydesk && !displayonlylap) || (displayonlydesk && item.typepc == 1) || (displayonlylap && item.typepc == 2))
    ));
  }, [displayonlydesk, displayonlylap, filterTextEquipment, computers]);

  const subHeaderComponentMemoEquipment = useMemo(() => {
    const handleClearEquipment = () => {
      if (filterTextEquipment) {
        setResetPaginationToggleEquipment(!resetPaginationToggleEquipment);
        setFilterTextEquipment("");
      }
    };
    const onFilterTextEquipment = (e) => setFilterTextEquipment(e.target.value);

    return (
      <>

        <SearchDiv>
          <SearchComponentEquipment
            key="SearchComponentEquipment"
            onFilter={onFilterTextEquipment}
            onClear={handleClearEquipment}
            filterText={filterTextEquipment}
          />
          <Tooltip title={geittext.displayonlylap}>
            <PlanMenuButton
              color={"success"}
              className={displayonlylap ? classes2.planmenubuttonpressed : classes2.planmenubutton}
              onClick={handleDisplayonlylapChange}
            >
              <Laptop className={classes2.planmenuicon} />
            </PlanMenuButton>
          </Tooltip>

          <Tooltip title={geittext.displayonlydesk}>
            <PlanMenuButton
              color={"success"}
              className={displayonlydesk ? classes2.planmenubuttonpressed : classes2.planmenubutton}
              onClick={handleDisplayonlydeskChange}
            >
              <Desktop className={classes2.planmenuicon} />
            </PlanMenuButton>
          </Tooltip>

        </SearchDiv>
        <SelectedText>{geittext.selectedpclength + " : " + selectedComputers.length}</SelectedText>
      </>
    );
  }, [filterTextEquipment, resetPaginationToggleEquipment, computers, displayonlylap, displayonlydesk, selectedComputers]);

  const setNotification = (status, text) => {
    if (status === "success") {
      NotificationManager.success(text);
    } else {
      NotificationManager.error(text);
    }
  };

  const handleSelectedRowsChange = (selection) => {
    console.log(selection);
    setSelectedComputers(selection.selectedRows);
  };

  const handleViewPointDataOpen = () => {
    setOpenPointData(true);
  };
  const handleViewPointDataClose = () => {
    setOpenPointData(false);
  };
  const handleViewPointOpen = () => {
    setOpenPoint(true);
  };
  const handleViewPointClose = () => {
    setOpenPoint(false);
  };

  return (
    <>
      <DataTable
        paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
        noDataComponent={<NoData>Aucun PC à afficher</NoData>}
        noHeader={true}
        columns={computerscolumns}
        persistTableHead
        pagination
        subHeader
        dense
        data={filteredComputers}
        onSelectedRowsChange={handleSelectedRowsChange}
        selectableRows={true}
        subHeaderComponent={subHeaderComponentMemoEquipment}
        subHeaderAlign={"left"}
        // progressPending={gridState.loading}
        progressComponent={<LinearProgress />}
        // expandOnRowClicked={displaymethod === 'equipments'}
        // expandableRows={displaymethod === 'equipments'}
        expandableRowDisabled={(row) => row.disabled}
        expandableRowsComponent={ExpandableComponent}
        paginationComponentOptions={{
          noRowsPerPage: false,
          rowsPerPageText: "Lignes par page",
          rangeSeparatorText: "sur",
          selectAllRowsItem: false,
          selectAllRowsItemText: "Selectionner toutes les lignes",
        }}
        defaultPageSize={10}
        defaultSortFieldId={1}
      />
    </>
  );
};

export default RTComputers;
